/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/prefer-primitives */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { HEADER_HEIGHT } from '../../common/constants';
import { SIDEBAR_WIDTH } from './constants';
export var PageActions = function PageActions() {
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Image, null));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var Wrapper = styled.div({
  position: 'fixed',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  top: "".concat(HEADER_HEIGHT, "px"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  right: "".concat(SIDEBAR_WIDTH, "px"),
  background: '#fff'
});
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "292",
    height: "112",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PageActionsA)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "120",
    height: "32",
    x: "24",
    y: "56",
    fill: "#091E42",
    fillOpacity: ".08",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "104",
    height: "6",
    x: "32",
    y: "69",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "80",
    height: "32",
    x: "150",
    y: "56",
    fill: "#091E42",
    fillOpacity: ".08",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "64",
    height: "6",
    x: "158",
    y: "69",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    x: "236",
    y: "56",
    fill: "#fff",
    fillOpacity: ".01",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M240 60h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    d: "M245 74a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM252 74a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM259 74a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "PageActionsA"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 56h244v32H24z"
  }))));
};